import React, { Component } from "react";
import { View, TouchableOpacity, Text, StyleSheet } from "react-native";

export default class RadioButton extends Component {
  state = {
    value: "IDFC First Bank Net Banking",
    transactTooltip:false
  };

  onClickTransactInfo = () => {
    this.setState(prevState => ({
      transactTooltip: !prevState.transactTooltip 
      }))
  };

  render() {
    const { PROP, selectedValue, orientation, dir, disabledBtn, redBg,editable,IsStatementFilter } = this.props;
    const { value,transactTooltip } = this.state;

    return (
      <View style={{ flexDirection: dir ? dir : "column", marginTop:10}}>
        {PROP.map(res => {
          return (
            <View key={res.key} style={[ styles.container,{ marginRight: orientation && orientation == "row" ? 45 : 0}]}>
              <TouchableOpacity
                onPress={() => {
                  editable ? null :
                  this.props.onSelect(res);
                  this.setState({
                    value: res.key
                  });
                }}
                style={{ flexDirection: 'row' }}
                disabled={disabledBtn || res?.disabled ? disabledBtn||res.disabled : false}
              >
                <View style={[styles.radioCircle,{ borderColor:res?.disabled ? '#CCD0D577':'#CCD0D5'}]}>
                  {selectedValue === res.key && (
                    <View style={redBg ? styles.selectedRbBrderRed :styles.selectedRbBrder}>
                      <View style={redBg ?styles.selectedRbRed:styles.selectedRb}></View>
                    </View>
                  )}
                </View>
                {selectedValue === res.key ? (
                  IsStatementFilter ?  <Text style={[redBg?styles.radioTextActiveRed:styles.radioTextActive ,{color:"white"}]}>{res.text}</Text> :
                  <Text style={redBg?styles.radioTextActiveRed:styles.radioTextActive}>{res.text}</Text> 
                ) : (
                  IsStatementFilter ? <Text style={[redBg?styles.radioTextActiveRed :(styles.radioText),{color:"white"}]}>{res.text} </Text>:
                  <Text style={[redBg?styles.radioTextActiveRed :(styles.radioText,{color:res?.disabled ? 'gray' : 'gray',})]}>{res.text} </Text>
                )}
              </TouchableOpacity>
            </View>
          );
        })}
       
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 15,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-start"
  },
  radioText: {
    fontFamily: 'Inter',
    fontSize: 15,
    color: 'white',
  },
  radioTextActive: {
    fontFamily: 'Inter',
    fontSize: 15,
    color: 'white'
  },
  radioTextActiveRed: {
    fontFamily: 'Inter',
    fontSize: 15,
    color: '#02122c'
  },
  radioCircle: {
    height: 20,
    width: 20,
    borderRadius: 40,
    borderWidth: 2,
    borderColor: "#CCD0D5",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 5
  },
  selectedRbBrder: {
    height: 20,
    width: 20,
    borderRadius: 40,
    borderWidth: 2,
    borderColor: "#fff",
    justifyContent: "center",
    alignItems: "center"
  },
  selectedRb: {
    width: 12,
    height: 12,
    borderRadius: 24,
    backgroundColor: "#fff"
  },
  selectedRbBrderRed: {
    height: 20,
    width: 20,
    borderRadius: 40,
    borderWidth: 2,
    borderColor: "#bd2d37",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor:'#fff'
  },
  selectedRbRed: {
    width: 12,
    height: 12,
    borderRadius: 24,
    backgroundColor: "#bd2d37"
  },
  result: {
    marginTop: 20,
    color: "white",
    fontWeight: "600",
    backgroundColor: "#fff"
  },
  
});
